import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Base from './../core/Base';
import { signin, authenticate, isAuthenticated } from '../apiCallsHelper/authapicalls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faPersonMilitaryPointing } from '@fortawesome/free-solid-svg-icons';
import LoadingOverlay from './../utils/LoadingOverlay';
import { toast } from 'react-toastify';



const Signin = () => {

    const navigate = useNavigate();

    const { user } = isAuthenticated();

    const [values, setValues] = useState({
        email: "",
        password: "",
        loading: false,
        didRedirect: false,
    });


    const { email, password, loading, didRedirect } = values;

    const [showPassword, setShowPassword] = useState(false);




    const handleChange = name => event => {
        setValues({ ...values, [name]: event.target.value });
    }


    const togglePasswordType = (event) => {
        event.preventDefault();
        setShowPassword(!showPassword);
    }


    const onSubmit = event => {
        event.preventDefault();
        setValues({ ...values, loading: true })
        signin({ email, password })
            .then(data => {
                if (data.error) {
                    toast.error(data.error, {
                        theme: "colored",
                    });
                    setValues({ ...values, error: data.error, loading: false });
                    if (data.isVerified === false) {
                        navigate("/account/verify/resend")
                    }
                }
                else {
                    authenticate(data, () => {
                        setValues({
                            ...values,
                            loading: false,
                            didRedirect: true,
                        })
                    })
                    toast.success(data.message, {
                        theme: "colored",
                    });
                }
            })
            .catch(error => {
                // console.log("signin request failed", error)
            });

    }



    const performRedirect = () => {
        if (didRedirect) {
            if (user && user.role === 25) {
                return <Navigate to="/admin/dashboard" />
            }
            else {
                return <Navigate to="/user/dashboard" />
            }
        }
        if (isAuthenticated()) {
            return <Navigate to="/" />
        }
    }





    return (
        <Base bgClass="bg-[#e8eefa]">
            <div className='h-screen'>
                <div className="bg-[#e8eefa]  h-full  md:h-[500px]">
                    <div className='text-[#7a91cc] mt-4 font-bold text-2xl text-center'>
                        Login
                    </div>
                    <div className=" h-full md:h-[500px] mt-4 flex items-center justify-center bg-[#e8eefa]">
                        <div className=" w-[450px] h-[340px]  xs:h-[370px]  md:h-[430px]  bg-white shadow-3xl ">
                            <div className="bg-[#b6cafc] absolute  left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full p-2 sm:p-3 md:p-4">
                                <FontAwesomeIcon icon={faPersonMilitaryPointing} color='#2b3a69' size='xl' />
                            </div>
                            <div className="p-4 xs:p-10 sm:p-14 md:p-14">
                                <form>
                                    <label className="block  text-gray-700 text-md font-bold "
                                        htmlFor="signInEmail">
                                        Email
                                    </label>
                                    <div className="flex items-center text-lg mb-6 md:mb-8">
                                        <svg className="absolute ml-3 mt-2" width="24" viewBox="0 0 24 24" fill="#9fb4f5">
                                            <path d="M20.822 18.096c-3.439-.794-6.64-1.49-5.09-4.418 4.72-8.912 1.251-13.678-3.732-13.678-5.082 0-8.464 4.949-3.732 13.678 1.597 2.945-1.725 3.641-5.09 4.418-3.073.71-3.188 2.236-3.178 4.904l.004 1h23.99l.004-.969c.012-2.688-.092-4.222-3.176-4.935z" />
                                        </svg>
                                        <input
                                            onChange={handleChange("email")}
                                            value={email}
                                            type="email"
                                            placeholder="Email"
                                            id="signInEmail"
                                            className="bg-[#e8edfa] text-black pl-12 py-2 md:py-3 focus:outline-[#7b9de3] w-full"
                                        />
                                    </div>
                                    <div className='flex  '>
                                        <label className="text-gray-700 text-md font-bold "
                                            htmlFor="signInPassword">
                                            Password
                                        </label>
                                        <Link className='text-blue-500 text-sm ml-auto hover:underline' to="/forgot-password">
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <div className="flex items-center text-lg mb-6 md:mb-8">
                                        <svg className="absolute ml-3" viewBox="0 0 24 24" width="24" fill="#9fb4f5">
                                            <path d="m18.75 9h-.75v-3c0-3.309-2.691-6-6-6s-6 2.691-6 6v3h-.75c-1.24 0-2.25 1.009-2.25 2.25v10.5c0 1.241 1.01 2.25 2.25 2.25h13.5c1.24 0 2.25-1.009 2.25-2.25v-10.5c0-1.241-1.01-2.25-2.25-2.25zm-10.75-3c0-2.206 1.794-4 4-4s4 1.794 4 4v3h-8zm5 10.722v2.278c0 .552-.447 1-1 1s-1-.448-1-1v-2.278c-.595-.347-1-.985-1-1.722 0-1.103.897-2 2-2s2 .897 2 2c0 .737-.405 1.375-1 1.722z" />
                                        </svg>
                                        <div className='flex w-full'>
                                            <input
                                                onChange={handleChange("password")}
                                                value={password}
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Password"
                                                id="signInPassword"
                                                className="bg-[#e8edfa] pl-12 py-2 md:py-3 focus:outline-[#7b9de3] w-full"
                                            />
                                            <button type="button" onClick={togglePasswordType}>
                                                {showPassword ?
                                                    (
                                                        <FontAwesomeIcon icon={faEye} className='ml-[-30px] mt-2' size='sm' color='#7292f7' />
                                                    ) : (
                                                        <FontAwesomeIcon icon={faEyeSlash} className='ml-[-30px] mt-2' size='sm' color='#7292f7' />
                                                    )}
                                            </button>
                                        </div>
                                    </div>
                                    <button onClick={onSubmit} className="mt-4 bg-gradient-to-b from-[#cfdcfa] to-[#87abff] font-bold p-2 md:p-4 text-[#34467d] uppercase w-full rounded-md hover:from-[#9cb8ff] hover:to-[#9cb8ff] ">Login</button>
                                </form>
                                <div className="text-xs mt-4 text-[#5f686e]">
                                    New to TodoMate? <Link className="text-blue-500 hover:underline" to="/signup">Signup</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {loading && <LoadingOverlay />}

                {performRedirect()}

            </div>

        </Base>

    )
}





export default Signin;